import { Props_SnippetIntroduction } from "./Introduction.props";
import SnippetLink from '../Shared/Link/Link';
import { Legacy_CompileMarkdown } from "../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler";

const SnippetIntroduction = (props: Props_SnippetIntroduction) => {
    const { snippet, heading, content, link } = props;
    const classHeadingVisibility: string = heading.visibility?.value === "hidden" ? ` snippet-introduction__heading--${heading.visibility.value}`: '';
    const classSnippetAlignment: string = snippet.alignment?.value ? ` snippet-introduction--alignment-${snippet.alignment.value}` : ''
    const classSnippetBorder: string = snippet.border?.value ? `snippet-introduction--border-${snippet.border.value}` : ''

    return (
        <section className={`snippet-introduction ${classSnippetAlignment} ${classSnippetBorder}`}>
            <div className="snippet-introduction__container">
                <div className="snippet-introduction__container-border">
                    <h2 className={`snippet-introduction__heading${classHeadingVisibility}`}>{heading.content.value}</h2>
                    {content.text.value && 
                        <div className="snippet-introduction__content">
                            {Legacy_CompileMarkdown(content.text.value)}
                        </div>
                    }
                    <SnippetLink 
                        linkStyles={link.linkStyle?.value} 
                        className="snippet-introduction__link"
                        url={link.linkHref?.value}
                        target={!!link.linkTarget?.value}
                    >
                        {link.linkContent?.value}
                    </SnippetLink>
                </div>
            </div>
        </section>
    );
}

export default SnippetIntroduction;